export default [
  "Draft",
  "Pending Approval",
  "Approved",
  "Issued",
  "Revised",
  "Denied",
];
